import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-top-menu-1',
  templateUrl: './nav-top-menu.component.html'
})
export class NavTopMenuComponent {
}
